// extracted by mini-css-extract-plugin
export var playerhigh = "player-module--playerhigh--77393";
export var playerwrapper = "player-module--playerwrapper--dbf03";
export var videoFixed = "player-module--videoFixed--d3ede";